export const PRODUCT_PERKS = {
  GAME_MEMBERSHIP: "game_membership",
  COACHING_DISCOUNT: "pg_points_discount",
  CREDIT: "pg_points",
}



// WEBPACK FOOTER //
// ./src/constants/products.js